import { IOrder } from "./../entities/Main";
import {
  ADD_SPR,
  LOAD_USERS,
  TOGGLE_IS_USERS_FETCHING,
  SET_ORDERS,
  SET_COUNT_NEW_ORDER,
  SET_TAGS,
  SET_SUPPLIERS,
  SET_SUPPLIER,
  SET_SHOPS,
  SET_SHOP,
  SET_VISIBLE_TRASH,
  SET_VISIBLE_CATALOG,
  SET_SELECT_FOOTER,
  SET_TEXT_HEADER,
  SET_VISIBLE_BACK_BUTTON,
  SET_VISIBLE_SHOPS,
  SET_IS_PERSON,
  SET_USER_INFO,
} from "../actions/usersActions";
import { ITbl } from "../entities/Tbl";
import cookie from "js-cookie";

type InitialStateType = {
  users: ITbl | null;
  sprs: Array<ITbl>;
  isUsersFetching: boolean;
  orders: Array<IOrder>;
  suppliers: any;
  supplier: any;
  shops: any;
  shop: any;
  visibleTrash: boolean;
  visibleCatalog: boolean;
  visibleShops: boolean;
  selectedFooter: string;
  textHeader: string;
  visibleBackButton: boolean;
  tags: any;
  countNewOrder: number;
  is_person: boolean;
  userInfo: any;
};

let initialState: InitialStateType = {
  users: null,
  sprs: [],
  isUsersFetching: false,
  orders: [],
  suppliers: [],
  supplier: null,
  shops: [],
  shop: null,
  visibleTrash: false,
  visibleCatalog: false,
  visibleShops: false,
  selectedFooter: "",
  textHeader: "",
  visibleBackButton: false,
  tags: [],
  countNewOrder: 0,
  is_person: cookie.get("is_person") === "true" ? true : false,
  userInfo: {},
};

const usersReducer = (state = initialState, action: any): InitialStateType => {
  switch (action.type) {
    case LOAD_USERS:
      return { ...state, users: action.users! };
    case ADD_SPR:
      let sprs = [...state.sprs];
      let sprIndex = sprs.findIndex((s) => s.code === action.spr!.code);
      if (sprIndex >= 0) {
        sprs[sprIndex] = action.spr!;
      } else {
        sprs.push(action.spr!);
      }
      return { ...state, sprs: sprs };
    case TOGGLE_IS_USERS_FETCHING:
      return { ...state, isUsersFetching: action.isUsersFetching! };
    case SET_ORDERS:
      return { ...state, orders: action.orders! };
    case SET_SUPPLIERS:
      return { ...state, suppliers: action.suppliers! };
    case SET_SUPPLIER:
      return { ...state, supplier: action.supplier! };
    case SET_SHOPS:
      return { ...state, shops: action.shops! };
    case SET_SHOP:
      return { ...state, shop: action.shop! };
    case SET_TAGS:
      return { ...state, tags: action.tags! };
    case SET_VISIBLE_TRASH:
      return { ...state, visibleTrash: action.visible! };
    case SET_VISIBLE_CATALOG:
      return { ...state, visibleCatalog: action.visible! };
    case SET_VISIBLE_SHOPS:
      return { ...state, visibleShops: action.visible! };
    case SET_SELECT_FOOTER:
      return { ...state, selectedFooter: action.text! };
    case SET_TEXT_HEADER:
      return { ...state, textHeader: action.text! };
    case SET_VISIBLE_BACK_BUTTON:
      return { ...state, visibleBackButton: action.visible! };
    case SET_COUNT_NEW_ORDER:
      return { ...state, countNewOrder: action.countNewOrder! };
    case SET_IS_PERSON:
      return { ...state, is_person: action.is_person! };
    case SET_USER_INFO:
      return { ...state, userInfo: action.userInfo! };
    default:
      return state;
  }
};

export default usersReducer;
